import { request } from '@/shared/api/request'

export const revokeGrant = (body) => request({ url: `admin/request/revokeGrant`, method: 'POST', params: body })